<template>
    <label :for="forId" :class="swatchClasses">
        <span
            class="absolute inset-0 transition-all duration-200 ease-in-out"
            :class="shapeClass"
            :style="{ backgroundColor: color }"
        ></span>
        <span v-if="$slots.overlay" class="pointer-events-none absolute inset-0 flex items-center justify-center">
            <slot name="overlay" />
        </span>
    </label>
</template>

<script>
'use strict';

const SWATCH_BASE = 'relative m-auto flex cursor-pointer items-center justify-center transition-opacity';
/* Both sizes sit below the minimum target size, so consumers pair them with `tap-target`. */
const SWATCH_SIZE_CLASSES = {
    filter: 'h-4 w-4',
    picker: 'h-5 w-5',
};
const SWATCH_INACTIVE = 'opacity-40 hover:opacity-70';
const SWATCH_ACTIVE_RING =
    "opacity-100 after:absolute after:-inset-[3px] after:border-2 after:border-theme-text after:opacity-60 after:content-['']";

export default {
    name: 'ColorSwatch',
    props: {
        forId: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        isCustom: {
            type: Boolean,
            default: false,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'picker',
            validator: value => Object.keys(SWATCH_SIZE_CLASSES).includes(value),
        },
    },
    computed: {
        /**
         * Returns the rounded class for the inner color fill — square corners for custom, full circle otherwise.
         * @returns {string}
         */
        shapeClass() {
            return this.isCustom ? 'rounded-md' : 'rounded-full';
        },
        /**
         * Returns the full Tailwind class string for the swatch label, combining shape, size and selection state.
         * @returns {string}
         */
        swatchClasses() {
            const ringShape = this.isCustom ? 'after:rounded-lg' : 'after:rounded-full';
            const stateClasses = this.isSelected ? `${SWATCH_ACTIVE_RING} ${ringShape}` : SWATCH_INACTIVE;
            return `${SWATCH_BASE} ${SWATCH_SIZE_CLASSES[this.size]} ${this.shapeClass} ${stateClasses}`;
        },
    },
};
</script>
